import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  Inject,
  PLATFORM_ID,
} from '@angular/core';

import { codeSnippets } from './utils';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PrismService } from 'src/app/prism.service';

type ApiType = keyof typeof codeSnippets;
type LanguageType = 'javascript' | 'python';

@Component({
  selector: 'app-prism-code',
  templateUrl: './prism-code.component.html',
  styleUrls: ['./prism-code.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class PrismCodeComponent implements OnInit, AfterViewInit {
  isBrowser: boolean;
  @ViewChild('pre', { static: true }) pre!: ElementRef;
  @ViewChild('parent', { static: true }) parent!: ElementRef;
  typingInterval: any;
  isTyping = false;

  @Input() apiType: ApiType = 'payment';
  @Input() language: LanguageType = 'javascript';
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private prismService: PrismService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.updateContent();
  }

  switchLanguage(language: LanguageType): void {
    this.language = language;
    this.updateContent();
  }

  updateContent(): void {
    const apiSnippets = codeSnippets[this.apiType];
    const newContent = apiSnippets?.[this.language] || '';
    this.typingEffect(newContent);
  }

  async copyCode(): Promise<void> {
    const element = this.pre.nativeElement.querySelector('code');
    const text = element?.textContent || '';
    await navigator.clipboard.writeText(text);
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) return;
    this.prismService.highlightAll();
  }

  typingEffect(text: string): void {
    this.isTyping = true;
    const element = this.pre.nativeElement.querySelector('code');

    if (element) {
      element.textContent = text;

      element.classList.remove('animate');

      // Trigger reflow to ensure the class removal is registered
      void element.offsetWidth;

      element.classList.add('animate');

      // Highlight the content after the animation
      setTimeout(() => this.prismService.highlightElement(element), 0);
    }

    this.isTyping = false;
  }
}
